import { cn } from 'app/lib/utils'
import { LoaderCircle } from 'lucide-react'
function Spinner({ className, children, ...rest }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('flex items-center justify-center gap-2 text-accent', className)} {...rest}>
      <LoaderCircle className="h-6 w-6 animate-spin" />
      {children}
    </div>
  )
}

export { Spinner }
